import { US_STATE_SHORT_CODES } from '../constants/UsStateAbbrevationConstants';

export const DEFAULT_SHIPPING_STATE = 'IL';

export function validateShippingStateOrGetDefault(stateShortCode: string) {
  return isValidShippingState(stateShortCode) ? stateShortCode : DEFAULT_SHIPPING_STATE;
}

function isValidShippingState(stateShortCode: string) {
  return US_STATE_SHORT_CODES.includes(stateShortCode) ? stateShortCode : undefined;
}
